export default __webpack_public_path__ + "static/AirForceEmblem2-a09bd7a4f8f4d5113ade14322973d4eb.jpg";